import { inject, InjectionToken } from '@angular/core';
import { ENVIRONMENT_SCORM_FEATURE_TOKEN } from '@campus/environment';
import { ScormAgainApi } from './scorm-again-api';
import { ScormApi } from './scorm-api';
import { ScormApiInterface } from './scorm-api.interface';

export const SCORM_API = new InjectionToken<ScormApiInterface>('ScormApi', {
  providedIn: 'root',
  factory: () => {
    const environment = inject(ENVIRONMENT_SCORM_FEATURE_TOKEN, { optional: true });
    return environment?.cors?.enabled ? inject(ScormAgainApi) : inject(ScormApi);
  },
});
